export const samplingSitesUrls = {
    // Sampling location
    samplingSites: (samplingSiteId?: number) => (samplingSiteId ? `crm/sampling-sites/${samplingSiteId}` : "crm/sampling-sites"),
    samplingPoints: (samplingPointId?: number) => (samplingPointId ? `crm/sampling-points/${samplingPointId}` : "crm/sampling-points"),

    samplingSitesFormData: "crm/sampling-sites-form-format",
    samplingPointsFormData: "/crm/sampling-points-form-format",
    samplingPointsFormDataBySiteIds: "crm/sampling-points/form-format",
};
